import cn from 'classnames';
import styles from './UpsaleSecondOfferCard.module.scss'
import { formatCentsToDollars } from '../../../../services/formatCentsToDollars';

export const UpsaleSecondOfferCard = ({content,currency,status,paid, ...props})=>{
  if(!content) return;
  const {title,sale, oldPrice,newPrice}=content;
  const old = formatCentsToDollars(oldPrice);
  const next = formatCentsToDollars(newPrice);
return (
  <div className={cn(
    styles.card,
    status==='active' && styles.active,
    paid===true && styles.paid
  )}  {...props}>
    {sale && <div className={styles.sale}>{sale}</div>}
    {title && <div className={styles.title}>{content.title}</div>}
    <div className={styles.price}>
      <div className={styles.oldPrice}>{currency} {old.integer}.{old.fraction}</div>
      <div className={styles.newPrice}>{currency} {next.integer}.{next.fraction} only</div>
    </div>
  </div>
)
}